import { Property, PropertyId, RepaymentStrategy } from '../RepaymentStrategy';
import { Endowment } from '../Endowment';
import { Investment } from '../Investment';
import { Actions, FieldPayload } from './store';
import { EndowmentId } from 'modules/cm/api/cases/repaymentStrategy/endowment/Endowment';
import { InvestmentId } from 'modules/cm/api/cases/repaymentStrategy/investment/Investment';

// Getting repayment strategy
export const gettingRepaymentStrategyStart = () => {
  return {
    type: Actions.SET_GETTING_DATA_START,
  };
};

export const gettingRepaymentStrategyFinish = (repaymentStrategy: RepaymentStrategy) => {
  return {
    type: Actions.SET_GETTING_DATA_FINISH,
    payload: repaymentStrategy,
  };
};

export const gettingRepaymentStrategyError = (error: string) => {
  return {
    type: Actions.SET_GETTING_DATA_ERROR,
    payload: error,
  };
};

// Updating repayment strategy
export const updatingRepaymentStrategyStart = (payload: FieldPayload) => {
  return {
    type: Actions.SET_UPDATING_DATA_START,
    payload,
  };
};
export const updatingRepaymentStrategyFinish = (payload: FieldPayload) => {
  return {
    type: Actions.SET_UPDATING_DATA_FINISH,
    payload,
  };
};

export const updatingRepaymentStrategyError = (payload: FieldPayload) => {
  return {
    type: Actions.SET_UPDATING_DATA_ERROR,
    payload,
  };
};

export const setPropertiesFinish = (payload: Property[]) => {
  return {
    type: Actions.SET_PROPERTIES_FINISH,
    payload,
  };
};

export const addProperty = (payload: Property) => {
  return {
    type: Actions.ADD_PROPERTY,
    payload,
  };
};

export const removeProperty = (payload: PropertyId) => {
  return {
    type: Actions.REMOVE_PROPERTY,
    payload,
  };
};

export const setEndowmentsFinish = (payload: Endowment[]) => {
  return {
    type: Actions.SET_ENDOWMENTS_FINISH,
    payload,
  };
};

export const addEndowment = (payload: Endowment) => {
  return {
    type: Actions.ADD_ENDOWMENT,
    payload,
  };
};

export const removeEndowment = (payload: EndowmentId) => {
  return {
    type: Actions.REMOVE_ENDOWMENT,
    payload,
  };
};

export const setInvestmentsFinish = (payload: Investment[]) => {
  return {
    type: Actions.SET_INVESTMENTS_FINISH,
    payload,
  };
};

export const addInvestment = (payload: Investment) => {
  return {
    type: Actions.ADD_INVESTMENT,
    payload,
  };
};

export const removeInvestment = (payload: InvestmentId) => {
  return {
    type: Actions.REMOVE_INVESTMENT,
    payload,
  };
};
